import axios from 'axios';
import { useAsync } from 'react-use';

import { getAuthToken } from '@providers/AuthProvider';
import { ApiEndpoints } from '@utils/endpoints';

const useDeliveryMethods = () => {
	const state = useAsync(async () => {
		const authorizationToken = await getAuthToken();

		const response = await axios.get(
			`${ApiEndpoints.memberPortal}/available-rx-delivery-methods/`,
			{
				headers: {
					authorizationToken,
				},
				responseType: 'json',
			}
		);

		const data = response?.data;
		return data;
	}, []);

	return state;
};

export default useDeliveryMethods;
